import { guideItems } from "@/data/promptData";
import { universalQualityPrinciple, universalTextRestrictions, universalVisualRestrictions } from "@/data/promptInstructions";

export default function GuidePage() {
  return (
    <div className="mx-auto max-w-7xl px-4 py-10 sm:px-6 lg:px-8" data-testid="guide-page">
      <div className="mb-10 max-w-3xl" data-testid="guide-heading-block">
        <p className="text-sm font-extrabold uppercase text-[#D97757]" data-testid="guide-kicker">Promptin rakenneopas</p>
        <h1 className="mt-2 font-heading text-4xl font-bold text-[#2C2F2E] sm:text-5xl" data-testid="guide-title">Hyvä prompti on selkeä ohje, ei arvausleikki</h1>
        <p className="mt-4 text-base leading-7 text-[#5C6360]" data-testid="guide-description">Kun promptissa on nämä osat, AI ymmärtää nopeammin mitä haluat ja millaisessa muodossa vastaus pitää antaa.</p>
      </div>
      <div className="grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3" data-testid="guide-card-grid">
        {guideItems.map((item, index) => (
          <article key={item.title} className="rounded-[1.75rem] border border-[#E8E5D9] bg-white p-6 shadow-[0_8px_30px_rgb(0,0,0,0.04)]" data-testid={`guide-card-${index}`}>
            <span className="mb-5 grid h-11 w-11 place-items-center rounded-2xl bg-[#4A6753] font-heading text-lg font-bold text-white" data-testid={`guide-number-${index}`}>{index + 1}</span>
            <h2 className="font-heading text-2xl font-bold text-[#2C2F2E]" data-testid={`guide-item-title-${index}`}>{item.title}</h2>
            <p className="mt-3 text-sm leading-7 text-[#5C6360]" data-testid={`guide-item-description-${index}`}>{item.description}</p>
          </article>
        ))}
      </div>
      <section className="mt-8 rounded-[1.75rem] border border-[#E8E5D9] bg-[#F5F3EC] p-6 sm:p-8" data-testid="guide-example-section">
        <h2 className="font-heading text-2xl font-bold text-[#2C2F2E]" data-testid="guide-example-title">Nopea perusrunko</h2>
        <pre className="mt-4 whitespace-pre-wrap rounded-[1.25rem] bg-white p-5 text-sm leading-7 text-[#2C2F2E]" data-testid="guide-example-prompt">{`Toimi [rooli].
Luo [formaatti] aiheesta [aihe].
Kohderyhmä on [kenelle].
Tavoite on [mitä halutaan saada aikaan].
Tyyli on [sävy ja tunnelma].
Huomioi [konteksti ja tärkeät asiat].
Vältä [rajoitteet].
Anna lopputulos muodossa [lista / taulukko / käsikirjoitus / valmis teksti].`}</pre>
      </section>
      <section className="mt-8 grid grid-cols-1 gap-5 lg:grid-cols-[0.9fr_1.1fr]" data-testid="guide-quality-section">
        <article className="rounded-[1.75rem] border border-[#E8E5D9] bg-white p-6 shadow-[0_8px_30px_rgb(0,0,0,0.04)] sm:p-8" data-testid="guide-quality-principle-card">
          <p className="text-sm font-extrabold uppercase text-[#D97757]" data-testid="guide-quality-kicker">Yleinen laatuperiaate</p>
          <h2 className="mt-2 font-heading text-2xl font-bold text-[#2C2F2E]" data-testid="guide-quality-title">Aidompi, luonnollisempi ja uskottavampi lopputulos</h2>
          <p className="mt-4 whitespace-pre-wrap text-sm leading-7 text-[#5C6360]" data-testid="guide-quality-text">{universalQualityPrinciple}</p>
        </article>
        <article className="rounded-[1.75rem] border border-[#E8E5D9] bg-white p-6 shadow-[0_8px_30px_rgb(0,0,0,0.04)] sm:p-8" data-testid="guide-negative-instructions-card">
          <h2 className="font-heading text-2xl font-bold text-[#2C2F2E]" data-testid="guide-negative-title">Negatiiviset ohjeet mukana tarvittaessa</h2>
          <div className="mt-5 grid grid-cols-1 gap-5 md:grid-cols-2" data-testid="guide-negative-lists">
            <div data-testid="guide-text-restrictions">
              <h3 className="font-heading text-lg font-bold text-[#2C2F2E]" data-testid="guide-text-restrictions-title">Teksteihin ja käsikirjoituksiin</h3>
              <ul className="mt-3 space-y-2 text-sm leading-6 text-[#5C6360]" data-testid="guide-text-restrictions-list">
                {universalTextRestrictions.map((item) => (
                  <li key={item} data-testid={`guide-text-restriction-${item.slice(0, 10).replaceAll(" ", "-")}`}>• {item}</li>
                ))}
              </ul>
            </div>
            <div data-testid="guide-visual-restrictions">
              <h3 className="font-heading text-lg font-bold text-[#2C2F2E]" data-testid="guide-visual-restrictions-title">Kuville ja videoille</h3>
              <ul className="mt-3 space-y-2 text-sm leading-6 text-[#5C6360]" data-testid="guide-visual-restrictions-list">
                {universalVisualRestrictions.slice(0, 4).map((item) => (
                  <li key={item} data-testid={`guide-visual-restriction-${item.slice(0, 10).replaceAll(" ", "-")}`}>• {item}</li>
                ))}
              </ul>
            </div>
          </div>
        </article>
      </section>
    </div>
  );
}